import { DistributeReq, DistributeDef } from "../type/distribute-def";

export class DistributeAdapter {
  static toInputDTO(req: DistributeReq): any {
    return {
      asset_id: req.asset_id,
      node: req.node,
      is_continuous: req.is_continuous,
      // 未指定なら BE 側の既定（false）に任せる
      ...(req.full_range != null ? { full_range: req.full_range } : {}),
    };
  }

  static toOutputDTO(res: any): DistributeDef {
    return res;
  }
}
